import { Button } from '@backyard-ui/core'

interface NewChatButtonProps {
  onClick: () => void
  threads: Array<{ isOpenThread: boolean }>
}

function NewChatButton({ onClick, threads }: NewChatButtonProps) {
  const hasOpenConversation = threads.some(
    thread => thread.isOpenThread === true
  )

  if (hasOpenConversation) {
    return null
  }

  return (
    <Button
      appearance="success"
      radius="lg"
      variant="solid"
      size="sm"
      onClick={onClick}>
      Iniciar nova conversa
    </Button>
  )
}

export default NewChatButton
